import { CSSProperties, ReactNode, forwardRef } from 'react';
import styles from './Pad.module.scss';
import classNames from 'classnames';

interface PadProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  variant?: 'shadow_small';
}

const Pad = forwardRef<HTMLDivElement, PadProps>(function Pad(
  { children, className, style, variant }: PadProps,
  ref
): JSX.Element {
  return (
    <div
      ref={ref}
      style={style}
      className={classNames(
        styles.root,
        variant === 'shadow_small' && styles.shadowSmall,
        className
      )}
    >
      {children}
    </div>
  );
});

export default Pad;
